import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Building2, Shield, Swords, Wand2, UserRound } from 'lucide-react';
const cards = [
    {
        href: 'buildings.html',
        icon: Building2,
        title: 'Épületlista kalkulátor',
        desc: 'Férőhely, termelés és tekercsek automatikus kiszámítása.',
        color: 'bg-primary text-primary-foreground',
        ring: 'focus-visible:ring-primary',
    },
    {
        href: 'war.html',
        icon: Shield,
        title: 'Háború kalkulátor',
        desc: 'Védő- és támadóerő kalkuláció kristálygömb és épületlista alapján.',
        color: 'bg-secondary text-secondary-foreground',
        ring: 'focus-visible:ring-secondary',
    },
    {
        href: 'spells.html',
        icon: Wand2,
        title: 'Varázslatok',
        desc: 'Ártó és kristálygömb varázslatok sikerességének kiszámítása pontlistából.',
        color: 'bg-primary/80 text-primary-foreground',
        ring: 'focus-visible:ring-primary',
    },
    {
        href: 'thief.html',
        icon: UserRound,
        title: 'Tolvajlás',
        desc: 'Tolvajlási akciók sikerességének és hatékonyságának kiszámítása.',
        color: 'bg-secondary/80 text-secondary-foreground',
        ring: 'focus-visible:ring-secondary',
    },
    {
        href: 'alliance-war.html',
        icon: Swords,
        title: 'Szövetségi háború',
        desc: '10v10 szövetségi csata kalkulátor: épületlista/kristálygömb importtal.',
        color: 'bg-accent text-accent-foreground',
        ring: 'focus-visible:ring-accent',
    },
];
export default function LandingPage() {
    return (_jsx("div", { className: "flex items-center justify-center min-h-[60vh] px-4 py-10", children: _jsxs("div", { className: "max-w-5xl w-full text-center space-y-8", children: [_jsxs("div", { children: [_jsx("h1", { className: "text-4xl md:text-5xl font-black text-foreground tracking-wide", children: "H\u00D3D\u00CDT\u00D3 KALKUL\u00C1TOR" }), _jsx("p", { className: "text-muted-foreground mt-3 text-sm md:text-base", children: "V\u00E1laszd ki, melyik kalkul\u00E1tort szeretn\u00E9d haszn\u00E1lni." })] }), _jsx("div", { className: "grid gap-5 grid-cols-2 md:grid-cols-3 lg:grid-cols-5", children: cards.map((card) => (_jsx("a", { href: card.href, className: `rounded-lg border border-border bg-card text-card-foreground shadow-card hover:shadow-card-hover transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 ${card.ring}`, children: _jsxs("div", { className: "p-6 flex flex-col items-center text-center space-y-3", children: [_jsx("div", { className: `w-16 h-16 rounded-2xl ${card.color} flex items-center justify-center`, children: _jsx(card.icon, { size: 32, strokeWidth: 1.8 }) }), _jsx("h2", { className: "text-lg font-semibold", children: card.title }), _jsx("p", { className: "text-muted-foreground text-sm leading-relaxed", children: card.desc })] }) }, card.href))) })] }) }));
}
